<div class="panel-section clickable clickable-list">
  <div class="d-flex">
    <div class="icon{{iconClass}}new iconDiv">
      <span></span>
    </div>
    <div class="ml1">
      <div class="section-title">
        {{prefferedName}}
        <app-detour *ngIf="isDetour"></app-detour>
      </div>
      <div>{{connection.operator}}</div>
    </div>
    @if (connection.delay && connection.delay > 0)
    {
    <div class="panel-delay mt1">
      +&nbsp;{{connection.delay}}&nbsp;min
    </div>
    }
    @else
    {
    <div class="panel-no-delay mt1">
      {{ 'včas' | translate }}
    </div>
    }
  </div>
  <div class="mt2">
    <div class="station-info">
      <span>{{connection.dep}}</span>
      <span class="fw-bolder">{{connection.depTime}}</span>
    </div>
    <div class="station-info">
      <span>{{connection.dest}}</span>
      <span class="fw-bolder">{{connection.destTime}}</span>
    </div>
  </div>
</div>
